import { isNotDefaultTab, TabInfo } from 'editor/src/store/editorModules/sidebar/types';

const isTabActive = (activeTab: TabInfo | undefined, tab: TabInfo) =>
  activeTab === tab || (!!activeTab && isNotDefaultTab(activeTab) && activeTab.id === tab);

export default isTabActive;
